module.exports = __webpack_public_path__ + "img/advance-tab-light.a3194a39.png";